export default __webpack_public_path__ + "static/media/inca2.cc5093ee.jpg";